(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireed50"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireed50"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("4l8Yq", function(module, exports) {

$parcel$export(module.exports, "ifSelectorExist", () => $3290158d6660df5d$export$9d8e10a1281777d0);
$parcel$export(module.exports, "getElement", () => $3290158d6660df5d$export$d16800b7e59a8051);
$parcel$export(module.exports, "getElements", () => $3290158d6660df5d$export$73eac51a39d6b0eb);
$parcel$export(module.exports, "ready", () => $3290158d6660df5d$export$28ee1007e174a2a6);
const $3290158d6660df5d$export$9d8e10a1281777d0 = (selector)=>{
    if (selector !== null && selector !== undefined) return true;
    else return false;
};
const $3290158d6660df5d$export$d16800b7e59a8051 = (el, wrap = document)=>{
    if (el == null) return undefined;
    if (typeof el === "string") try {
        return wrap.querySelector(el) || undefined;
    } catch ({ message: message }) {
        console.error(message);
        return undefined;
    }
};
const $3290158d6660df5d$export$73eac51a39d6b0eb = (el, wrap = document)=>{
    if (el == null) return undefined;
    if (typeof el === "string") try {
        return wrap.querySelectorAll(el) || undefined;
    } catch ({ message: message }) {
        console.error(message);
        return undefined;
    }
};
const $3290158d6660df5d$export$1d567c320f4763bc = (el, property)=>window.getComputedStyle(el).getPropertyValue(property);
const $3290158d6660df5d$export$dbf350e5966cf602 = (el, css)=>{
    Object.keys(css).forEach((prop)=>{
        el.style[prop] = css[prop];
    });
};
const $3290158d6660df5d$export$28ee1007e174a2a6 = (callback)=>{
    if (document.readyState !== "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
};
const $3290158d6660df5d$export$4d721c3bfe35a861 = (e)=>{
    e.cancelable !== false && e.preventDefault();
    e.stopPropagation();
};
const $3290158d6660df5d$export$deed561b1a0ff1ea = (target, duration = 500)=>{
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.boxSizing = "border-box";
    target.style.height = target.offsetHeight + "px";
    target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(()=>{
        target.style.display = "none";
        target.style.removeProperty("height");
        target.style.removeProperty("padding-top");
        target.style.removeProperty("padding-bottom");
        target.style.removeProperty("margin-top");
        target.style.removeProperty("margin-bottom");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
    //alert("!");
    }, duration);
};
const $3290158d6660df5d$export$abdd11a06a163232 = (target, duration = 500, displayStyle = "block")=>{
    target.style.removeProperty("display");
    let display = window.getComputedStyle(target).display;
    if (display === "none") display = displayStyle;
    target.style.display = display;
    let height = target.offsetHeight;
    target.style.overflow = "hidden";
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = "border-box";
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + "ms";
    target.style.height = height + "px";
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    window.setTimeout(()=>{
        target.style.removeProperty("height");
        target.style.removeProperty("overflow");
        target.style.removeProperty("transition-duration");
        target.style.removeProperty("transition-property");
    }, duration);
};
const $3290158d6660df5d$export$715de50cedc228a8 = (target, duration = 500, displayStyle = "block")=>{
    if (window.getComputedStyle(target).display === "none") return $3290158d6660df5d$export$abdd11a06a163232(target, duration, displayStyle);
    else return $3290158d6660df5d$export$deed561b1a0ff1ea(target, duration);
};
const $3290158d6660df5d$export$8c8705df4a2dcec9 = function(event, elem, callback, capture) {
    if (typeof elem === "function") {
        capture = callback;
        callback = elem;
        elem = window;
    }
    capture = capture ? true : false;
    elem = typeof elem === "string" ? document.querySelector(elem) : elem;
    if (!elem) return;
    elem.removeEventListener(event, callback, capture);
};
const $3290158d6660df5d$export$a41d61df4ac70627 = (date)=>{
    let dateObj = void 0;
    if (typeof date === "string") dateObj = new Date(date);
    else dateObj = date;
    let options = {
        month: "long",
        day: "numeric"
    };
    let dateYear = dateObj.toLocaleString("latn", {
        year: "numeric"
    });
    let dateMonth = dateObj.toLocaleString("latn", {
        month: "numeric"
    });
    let dateDay = dateObj.toLocaleString("latn", {
        day: "numeric"
    });
    let dateHour = dateObj.getHours();
    let dateMinute = dateObj.getMinutes();
    let now = new Date();
    let nowYear = now.toLocaleString("latn", {
        year: "numeric"
    });
    let nowMonth = now.toLocaleString("latn", {
        month: "numeric"
    });
    let nowDay = now.toLocaleString("latn", {
        day: "numeric"
    });
    let nowHour = now.getHours();
    let nowMinute = now.getMinutes();
    // set year only if not the same year as now
    if (dateYear !== nowYear) options.year = "numeric";
    // if today, display relative time
    if (dateYear === nowYear && dateMonth === nowMonth && dateDay === nowDay) {
        let diffHour = nowHour - dateHour;
        let diffMinute = Math.abs(nowMinute - dateMinute);
        if (diffHour === 0 && diffMinute > 30) return "1 h";
        else if (diffHour === 0) return diffMinute + " min";
        else if (diffMinute >= 30) return diffHour + 1 + " h";
        return diffHour + " h";
    }
    return dateObj.toLocaleString("latn", options);
};
const $3290158d6660df5d$export$110700823644f4a6 = (name, value, days)=>{
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + days * 86400000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
};
const $3290158d6660df5d$export$4be65e66cfa2648a = (name)=>{
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for(let i = 0; i < ca.length; i++){
        let c = ca[i];
        while(c.charAt(0) == " ")c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};
const $3290158d6660df5d$export$84a9c3647d39324f = (name)=>{
    document.cookie = name + "=; Max-Age=-99999999;";
};
const $3290158d6660df5d$export$411a36e344f94698 = window.innerWidth;
const $3290158d6660df5d$export$3f99968195accfaf = (element, to, duration)=>{
    if (duration <= 0) return;
    var difference = to - element.scrollTop;
    var perTick = difference / duration * 10;
    setTimeout(function() {
        element.scrollTop = element.scrollTop + perTick;
        if (element.scrollTop === to) return;
        $3290158d6660df5d$export$3f99968195accfaf(element, to, duration - 10);
    }, 10);
};
const $3290158d6660df5d$export$c091916f1530334c = (el)=>{
    el.style.opacity = 1;
    (function fade() {
        if ((el.style.opacity -= 0.1) < 0) el.style.display = "none";
        else requestAnimationFrame(fade);
    })();
};
const $3290158d6660df5d$export$82e6205b15e6c637 = (el, display)=>{
    el.style.opacity = 0;
    el.style.display = display || "block";
    (function fade() {
        var val = parseFloat(el.style.opacity);
        if (!((val += 0.1) >= 1)) {
            if (!((val += 0.1) > 1)) {
                el.style.opacity = val;
                requestAnimationFrame(fade);
            }
        }
    })();
};
const $3290158d6660df5d$export$4140e97b68e1124c = ()=>{
    const allElements = Array.prototype.slice.call(document.querySelectorAll("*"));
    allElements.push(document);
    allElements.push(window);
    const types = [];
    for(let ev in window)if (/^on/.test(ev)) types[types.length] = ev;
    let elements = [];
    for(let i = 0; i < allElements.length; i++){
        const currentElement = allElements[i];
        for(let j = 0; j < types.length; j++)if (typeof currentElement[types[j]] === "function") elements.push({
            node: currentElement,
            type: types[j],
            func: currentElement[types[j]].toString()
        });
    }
    return elements.sort(function(a, b) {
        return a.type.localeCompare(b.type);
    });
};

});

var $d5d42260839de823$exports = {};
/*! lozad.js - v1.16.0 - 2020-09-06
* https://github.com/ApoorvSaxena/lozad.js
* Copyright (c) 2020 Apoorv Saxena; Licensed MIT */ !function(t, e) {
    $d5d42260839de823$exports = e();
}($d5d42260839de823$exports, function() {
    "use strict";
    /**
   * Detect IE browser
   * @const {boolean}
   * @private
   */ var g = "undefined" != typeof document && document.documentMode, f = {
        rootMargin: "0px",
        threshold: 0,
        load: function(t) {
            if ("picture" === t.nodeName.toLowerCase()) {
                var e = t.querySelector("img"), r = !1;
                null === e && (e = document.createElement("img"), r = !0), g && t.getAttribute("data-iesrc") && (e.src = t.getAttribute("data-iesrc")), t.getAttribute("data-alt") && (e.alt = t.getAttribute("data-alt")), r && t.append(e);
            }
            if ("video" === t.nodeName.toLowerCase() && !t.getAttribute("data-src") && t.children) {
                for(var a = t.children, o = void 0, i = 0; i <= a.length - 1; i++)(o = a[i].getAttribute("data-src")) && (a[i].src = o);
                t.load();
            }
            t.getAttribute("data-poster") && (t.poster = t.getAttribute("data-poster")), t.getAttribute("data-src") && (t.src = t.getAttribute("data-src")), t.getAttribute("data-srcset") && t.setAttribute("srcset", t.getAttribute("data-srcset"));
            var n = ",";
            if (t.getAttribute("data-background-delimiter") && (n = t.getAttribute("data-background-delimiter")), t.getAttribute("data-background-image")) t.style.backgroundImage = "url('" + t.getAttribute("data-background-image").split(n).join("'),url('") + "')";
            else if (t.getAttribute("data-background-image-set")) {
                var d = t.getAttribute("data-background-image-set").split(n), u = d[0].substr(0, d[0].indexOf(" ")) || d[0]; // Substring before ... 1x
                u = -1 === u.indexOf("url(") ? "url(" + u + ")" : u, 1 === d.length ? t.style.backgroundImage = u : t.setAttribute("style", (t.getAttribute("style") || "") + "background-image: " + u + "; background-image: -webkit-image-set(" + d + "); background-image: image-set(" + d + ")");
            }
            t.getAttribute("data-toggle-class") && t.classList.toggle(t.getAttribute("data-toggle-class"));
        },
        loaded: function() {}
    };
    function A(t) {
        t.setAttribute("data-loaded", !0);
    }
    var m = function(t) {
        return "true" === t.getAttribute("data-loaded");
    }, v = function(t) {
        var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : document;
        return t instanceof Element ? [
            t
        ] : t instanceof NodeList ? t : e.querySelectorAll(t);
    };
    return function() {
        var r, a, o = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : ".lozad", t = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, e = Object.assign({}, f, t), i = e.root, n = e.rootMargin, d = e.threshold, u = e.load, g = e.loaded, s = void 0;
        "undefined" != typeof window && window.IntersectionObserver && (s = new IntersectionObserver((r = u, a = g, function(t, e) {
            t.forEach(function(t) {
                (0 < t.intersectionRatio || t.isIntersecting) && (e.unobserve(t.target), m(t.target) || (r(t.target), A(t.target), a(t.target)));
            });
        }), {
            root: i,
            rootMargin: n,
            threshold: d
        }));
        for(var c, l = v(o, i), b = 0; b < l.length; b++)(c = l[b]).getAttribute("data-placeholder-background") && (c.style.background = c.getAttribute("data-placeholder-background"));
        return {
            observe: function() {
                for(var t = v(o, i), e = 0; e < t.length; e++)m(t[e]) || (s ? s.observe(t[e]) : (u(t[e]), A(t[e]), g(t[e])));
            },
            triggerLoad: function(t) {
                m(t) || (u(t), A(t), g(t));
            },
            observer: s
        };
    };
});


var $3e417c1b62ba0f8a$exports = {};
!function(e) {
    $3e417c1b62ba0f8a$exports = e();
}(function() {
    return (function e(n, t, o) {
        function r(c, u) {
            if (!t[c]) {
                if (!n[c]) {
                    var s = undefined;
                    if (!u && s) return s(c, !0);
                    if (i) return i(c, !0);
                    var a = new Error("Cannot find module '" + c + "'");
                    throw a.code = "MODULE_NOT_FOUND", a;
                }
                var l = t[c] = {
                    exports: {}
                };
                n[c][0].call(l.exports, function(e) {
                    return r(n[c][1][e] || e);
                }, l, l.exports, e, n, t, o);
            }
            return t[c].exports;
        }
        for(var i = undefined, c = 0; c < o.length; c++)r(o[c]);
        return r;
    })({
        1: [
            function(e, n, t) {
                "use strict";
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.create = t.visible = void 0;
                var o = function(e) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], t = document.createElement("div");
                    return t.innerHTML = e.trim(), !0 === n ? t.children : t.firstChild;
                }, r = function(e, n) {
                    var t = e.children;
                    return 1 === t.length && t[0].tagName === n;
                }, i = function(e) {
                    return null != (e = e || document.querySelector(".basicLightbox")) && !0 === e.ownerDocument.body.contains(e);
                };
                t.visible = i;
                t.create = function(e, n) {
                    var t = function(e, n) {
                        var t = o('\n		<div class="basicLightbox '.concat(n.className, '">\n			<div class="basicLightbox__placeholder" role="dialog"></div>\n		</div>\n	')), i = t.querySelector(".basicLightbox__placeholder");
                        e.forEach(function(e) {
                            return i.appendChild(e);
                        });
                        var c = r(i, "IMG"), u = r(i, "VIDEO"), s = r(i, "IFRAME");
                        return !0 === c && t.classList.add("basicLightbox--img"), !0 === u && t.classList.add("basicLightbox--video"), !0 === s && t.classList.add("basicLightbox--iframe"), t;
                    }(e = function(e) {
                        var n = "string" == typeof e, t = e instanceof HTMLElement == 1;
                        if (!1 === n && !1 === t) throw new Error("Content must be a DOM element/node or string");
                        return !0 === n ? Array.from(o(e, !0)) : "TEMPLATE" === e.tagName ? [
                            e.content.cloneNode(!0)
                        ] : Array.from(e.children);
                    }(e), n = function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        if (null == (e = Object.assign({}, e)).closable && (e.closable = !0), null == e.className && (e.className = ""), null == e.onShow && (e.onShow = function() {}), null == e.onClose && (e.onClose = function() {}), "boolean" != typeof e.closable) throw new Error("Property `closable` must be a boolean");
                        if ("string" != typeof e.className) throw new Error("Property `className` must be a string");
                        if ("function" != typeof e.onShow) throw new Error("Property `onShow` must be a function");
                        if ("function" != typeof e.onClose) throw new Error("Property `onClose` must be a function");
                        return e;
                    }(n)), c = function(e) {
                        return !1 !== n.onClose(u) && function(e, n) {
                            return e.classList.remove("basicLightbox--visible"), setTimeout(function() {
                                return !1 === i(e) || e.parentElement.removeChild(e), n();
                            }, 410), !0;
                        }(t, function() {
                            if ("function" == typeof e) return e(u);
                        });
                    };
                    !0 === n.closable && t.addEventListener("click", function(e) {
                        e.target === t && c();
                    });
                    var u = {
                        element: function() {
                            return t;
                        },
                        visible: function() {
                            return i(t);
                        },
                        show: function(e) {
                            return !1 !== n.onShow(u) && function(e, n) {
                                return document.body.appendChild(e), setTimeout(function() {
                                    requestAnimationFrame(function() {
                                        return e.classList.add("basicLightbox--visible"), n();
                                    });
                                }, 10), !0;
                            }(t, function() {
                                if ("function" == typeof e) return e(u);
                            });
                        },
                        close: c
                    };
                    return u;
                };
            },
            {}
        ]
    }, {}, [
        1
    ])(1);
});



var $4l8Yq = parcelRequire("4l8Yq");

var $4l8Yq = parcelRequire("4l8Yq");
const $cd775b032105bdfd$export$fb6dfdeffacf839b = ()=>{
    // setup page id to the form
    let containerPostFields = (0, $4l8Yq.getElements)('input[name="post_id"]');
    if ((0, $4l8Yq.ifSelectorExist)(containerPostFields)) {
        console.log("cl before foreach");
        Array.from(containerPostFields).forEach((input)=>{
            console.log("cl inside foreach");
            input.value = wpAjax.page_id;
            console.log("input.value == ", input.value);
        });
    }
};


const $3acce73fe90330d2$var$observer = (0, (/*@__PURE__*/$parcel$interopDefault($d5d42260839de823$exports)))();
$3acce73fe90330d2$var$observer.observe();
const $3acce73fe90330d2$var$m = document.getElementById("mob_menu");
const $3acce73fe90330d2$var$mo = document.getElementById("mm_over");
const $3acce73fe90330d2$var$mobileMenuBtn = document.querySelector(".mobile_menu_toggle");
const $3acce73fe90330d2$var$mobileMenuClose = document.querySelector(".mobile_menu_close");
function $3acce73fe90330d2$var$scrollFunction() {
    if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        if (!document.getElementById("header").classList.contains("scrolled")) document.getElementById("header").className += " scrolled ";
    } else document.getElementById("header").classList.remove("scrolled");
}
function $3acce73fe90330d2$var$showMobMenu(evt) {
    evt.preventDefault();
    $3acce73fe90330d2$var$m.className += " active";
    $3acce73fe90330d2$var$mo.className += " active";
}
function $3acce73fe90330d2$var$hideMobMenu(evt) {
    evt.preventDefault();
    $3acce73fe90330d2$var$m.classList.remove("active");
    $3acce73fe90330d2$var$mo.classList.remove("active");
}
window.onscroll = function onScrollFunction() {
    $3acce73fe90330d2$var$scrollFunction();
};
$3acce73fe90330d2$var$mobileMenuBtn.addEventListener("click", $3acce73fe90330d2$var$showMobMenu, false);
$3acce73fe90330d2$var$mobileMenuClose.addEventListener("click", $3acce73fe90330d2$var$hideMobMenu, false);
$3acce73fe90330d2$var$mo.addEventListener("click", $3acce73fe90330d2$var$hideMobMenu, false);
const $3acce73fe90330d2$var$buttonIframe = (0, $4l8Yq.getElement)(".mike-morse-video-block");
if ((0, $4l8Yq.ifSelectorExist)($3acce73fe90330d2$var$buttonIframe)) $3acce73fe90330d2$var$buttonIframe.onclick = ()=>{
    console.log($3e417c1b62ba0f8a$exports);
    $3e417c1b62ba0f8a$exports.create('<iframe width="80%" height="100%" src="https://www.youtube.com/embed/OXfzCMstVkg" frameborder="0" allowfullscreen></iframe>').show();
};
const $3acce73fe90330d2$var$buttonsIframeLsaPage = (0, $4l8Yq.getElements)(".lsa-page--video-block"); // Note that the variable is now plural: buttonsIframeLsaPage
function $3acce73fe90330d2$var$onYouTubeIframeAPIReady() {
    if ((0, $4l8Yq.ifSelectorExist)($3acce73fe90330d2$var$buttonsIframeLsaPage)) Array.from($3acce73fe90330d2$var$buttonsIframeLsaPage).forEach((button)=>{
        button.addEventListener("click", ()=>{
            let videoId = button.getAttribute("data-youtube-id");
            instance = $3e417c1b62ba0f8a$exports.create(`
                    <div style="position: relative;">
                        <div id="player"></div>
                        <button id="basicLightbox--close-icon">
                            &times;
                        </button>
                    </div>
                    `);
            instance.show();
            // Event listener for the close button
            const closeIcon = document.getElementById("basicLightbox--close-icon");
            if (closeIcon) closeIcon.addEventListener("click", $3acce73fe90330d2$var$closeLightbox);
            player = new YT.Player("player", {
                height: "100%",
                width: "80%",
                videoId: videoId,
                events: {
                    "onReady": $3acce73fe90330d2$var$onPlayerReady
                }
            });
        });
    });
}
function $3acce73fe90330d2$var$onPlayerReady(event) {
    event.target.playVideo();
    event.target.unMute();
}
// Function to close the lightbox
function $3acce73fe90330d2$var$closeLightbox() {
    if (instance) instance.close();
}
// Event listener for the ESC key
document.addEventListener("keydown", function(event) {
    if (event.key === "Escape" || event.keyCode === 27) $3acce73fe90330d2$var$closeLightbox();
});
let $3acce73fe90330d2$var$preloader = document.querySelector(".preloader");
if ((0, $4l8Yq.ifSelectorExist)($3acce73fe90330d2$var$preloader)) window.addEventListener("load", function() {
    // Find the preloader element and hide it
    $3acce73fe90330d2$var$preloader.style.display = "none";
});
(0, $4l8Yq.ready)(()=>{
    (0, $cd775b032105bdfd$export$fb6dfdeffacf839b)();
    $3acce73fe90330d2$var$onYouTubeIframeAPIReady();
});

})();
//# sourceMappingURL=script.js.map
